import Dropdown from "../../Components/Fields/Dropdown";
import {
  CheckMandatory,
  DeleteRecord,
  ErrorAlert,
  getList,
  GetListDropdown,
  GetRecords,
  saveRecord,
  SuccessAlert,
  UpdateRecord,
  URLPRIFIX,
  WarningAlert,
} from "../../functions/api";
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import String from "../../Components/Fields/String";
import { useStore } from "../../Components/StateProvider";
import FormView from "../../Components/Elements/FormView";
import ListView from "../../Components/Elements/ListView";
import DatePicker from "../../Components/Fields/DatePicker";
import Journal from "../../Components/Fields/Journal";
import FileInput from "../../Components/Fields/FileInput";
import Attachement from "../../Components/Fields/Attachement";
import { logDOM } from "@testing-library/react";
import { getlocal } from "../../functions/localstorage";
import { toast } from "react-toastify";
import { PrimaryBTN, secondaryBTN } from "../../Constancs/cssconst";
import Select from "react-select";
import { FaEdit, FaCheck, FaTimes, FaTrash } from "react-icons/fa";
import { FaDeleteLeft } from "react-icons/fa6";


const DocumentsForm = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const { option, id } = useParams();
  const user = getlocal("system")?.user || {};
  const tablename = "document";
  const setrecord = "/tasks/createtask/11";
  const getrecord = `/tasks/gettask/${id}`;
  const updaterecord = "/tasks/updatetask/" + id + "/11";
  const [GenerateInvoice, setGenerateInvoice] = useState(false);
  const [CompanyNumber, setCompanyNumber] = useState("");
  const [CompanyList, setCompanyList] = useState([
    { label: "Please Choose", value: "" },
  ]);
  const store = useStore();
  const init = {
    project_id: "",
    form_id: "0",
    film_id: "",
    contact_id: "",
    assigned_to: "0",
    task_title: "",
    dueDate: "",
    priority: "",
    editor_id: "0",
    status: "Draft",
    description: "",
    attachmenturl: [],
    activeStatus: true,
    child: [],
  };

  useEffect(() => {
    store.startLoading();
    store.setmodule("nonlitigation_document", init).then(async () => {
      await GetListDropdown({
        listUrl: "/api/v2/Customer/getclients",
        field: "clientname",
        sort: "asc",
        count: 100,
        store: store,
      });
      await GetListDropdown({
        listUrl: "/api/FilmMaster/getfilms",
        field: "film_name",
        sort: "asc",
        count: 100,
        store: store,
      });
      GetProjectList();
      GetAssigntoList();

      if (id != undefined) {
        store.setheader(option.toUpperCase() + " " + tablename);

        if (option === "view") {
          store.setprops("status", { hidden: false, readonly: true });
          store.setprops("activeStatus", { hidden: false, readonly: true });
          store.setprops("dueDate", { hidden: false, readonly: true });
          store.setprops("description", { hidden: false, readonly: true });
          store.setprops("priority", { hidden: false, readonly: true });
          store.setprops("project_id", { mandatory: false, readonly: true });
          store.setprops("form_id", { mandatory: false, readonly: true });
          store.setprops("film_id", { mandatory: false, readonly: true });
          store.setprops("contact_id", { mandatory: false, readonly: true });
          store.setprops("assigned_to", { mandatory: false, readonly: true });
          store.setprops("task_title", { mandatory: false, readonly: true });
          store.setprops("dueDate", { mandatory: false, readonly: true });
        } else {
          store.setprops("status", { hidden: false, readonly: false });
          store.setprops("activeStatus", { hidden: false, readonly: false });
          store.setprops("dueDate", { hidden: false, readonly: false });
          store.setprops("description", { hidden: false, readonly: false });
          store.setprops("priority", { hidden: false, readonly: false });
          store.setprops("project_id", { mandatory: false, readonly: true });
          store.setprops("form_id", { mandatory: false, readonly: true });
          store.setprops("film_id", { mandatory: false, readonly: true });
          store.setprops("contact_id", { mandatory: false, readonly: true });
          store.setprops("assigned_to", { mandatory: false, readonly: false });
          store.setprops("task_title", { mandatory: false, readonly: false });
          store.setprops("dueDate", { mandatory: false, readonly: false });
        }

        LoadInitData();
      } else {
        gettemplateType();
        const data = store.getrecord("nonlitigation_document") || {};
        if (
          data.contact_id !== "" &&
          data.contact_id !== undefined &&
          (data.project_id === "" || data.project_id === undefined)
        ) {
          let client =
            store.getallprops()?.nonlitigation_document?.clientname_list;
          if (client != undefined) {
            client = client.find((item) => item.value == data.contact_id);
            if (client != undefined) {
              GetProjectList(client);
            }
          }
        } else if (data.project_id !== "" && data.project_id !== undefined) {
          projectNameChange(data.project_id);
        }

        store.setheader("CREATE NEW " + tablename);
        store.setprops("activeStatus", { hidden: true });
        store.setprops("status", { hidden: true });
        store.setvalue("status", "Draft");
        store.setprops(
          "project_id",
          queryParams.get("project_id")
            ? {
              mandatory: queryParams.get("project_id").includes("mandatory"),
              readonly: queryParams.get("project_id").includes("readonly"),
              hidden: queryParams.get("project_id").includes("hidden"),
            }
            : { mandatory: true }
        );
        store.setprops(
          "form_id",
          queryParams.get("form_id")
            ? {
              mandatory: queryParams.get("form_id").includes("mandatory"),
              readonly: queryParams.get("form_id").includes("readonly"),
              hidden: queryParams.get("form_id").includes("hidden"),
            }
            : { hidden: true }
        );
        store.setprops(
          "film_id",
          queryParams.get("film_id")
            ? {
              mandatory: queryParams.get("film_id").includes("mandatory"),
              readonly: queryParams.get("film_id").includes("readonly"),
              hidden: queryParams.get("film_id").includes("hidden"),
            }
            : { hidden: true }
        );
        store.setprops(
          "contact_id",
          queryParams.get("contact_id")
            ? {
              mandatory: queryParams.get("contact_id").includes("mandatory"),
              readonly: queryParams.get("contact_id").includes("readonly"),
              hidden: queryParams.get("contact_id").includes("hidden"),
            }
            : { mandatory: true }
        );
        store.setprops(
          "assigned_to",
          queryParams.get("assigned_to")
            ? {
              mandatory: queryParams.get("assigned_to").includes("mandatory"),
              readonly: queryParams.get("assigned_to").includes("readonly"),
              hidden: queryParams.get("assigned_to").includes("hidden"),
            }
            : { mandatory: true }
        );
        store.setprops(
          "task_title",
          queryParams.get("task_title")
            ? {
              mandatory: queryParams.get("task_title").includes("mandatory"),
              readonly: queryParams.get("task_title").includes("readonly"),
              hidden: queryParams.get("task_title").includes("hidden"),
            }
            : { mandatory: true }
        );
        store.setprops(
          "dueDate",
          queryParams.get("dueDate")
            ? {
              mandatory: queryParams.get("dueDate").includes("mandatory"),
              readonly: queryParams.get("dueDate").includes("readonly"),
              hidden: queryParams.get("dueDate").includes("hidden"),
            }
            : { mandatory: true }
        );
        store.setprops(
          "priority",
          queryParams.get("priority")
            ? {
              mandatory: queryParams.get("priority").includes("mandatory"),
              readonly: queryParams.get("priority").includes("readonly"),
              hidden: queryParams.get("priority").includes("hidden"),
            }
            : { mandatory: false }
        );
        store.setprops(
          "description",
          queryParams.get("description")
            ? {
              mandatory: queryParams.get("description").includes("mandatory"),
              readonly: queryParams.get("description").includes("readonly"),
              hidden: queryParams.get("description").includes("hidden"),
            }
            : { mandatory: false }
        );
        store.stopLoading();
      }
    });
  }, [option, id]);

  async function GetAssigntoList() {
    GetListDropdown({
      listUrl: "/users/getusers",
      field: "userName",
      sort: "asc",
      count: 100,
      store: store,
    });
    await getList({
      listUrl: "/users/getusers",
      field: "userName",
      sort: "asc",
      count: 10000,
    }).then((users) => {
      if (users.success) {
        users = users?.data?.list || [];
        console.log("userName_list", users);
        users = users.map((user) => ({
          ...user,
          value: user.id,
          label: user.firstName + " " + user.lastName,
        }));
        users.splice(0, 0, {
          value: 0,
          label: "Select",
        });
        store.setprops("userName_list", users);
      }
    });
  }

  function LoadInitData() {
    GetRecords(getrecord).then(async (res) => {
      console.log(tablename + " Data - ", res, res.record);
      if (res.success) {
        init.project_id = res.record.parent[0].project_id;
        init.form_id = res.record.parent[0].form_id;
        init.film_id = res.record.parent[0].film_id;
        init.contact_id = res.record.parent[0].contact_id;
        init.assigned_to = res.record.parent[0].assigned_to;
        init.task_title = res.record.parent[0].task_title;
        init.dueDate = res.record.parent[0].dueDate;
        init.priority = res.record.parent[0].priority;
        init.status = res.record.parent[0].status;
        init.description = res.record.parent[0].description;
        init.editor_id = res.record.parent[0].editor_id;
        init.attachmenturl = res.record.parent[0].attachmenturl || [];
        GetArtistList(
          res.record.parent[0].contact_id,
          res.record.parent[0].film_id
        );

        // init.activeStatus = res.record.parent[0].activeStatus;
        if (option === "view") {
          init.child = {};
          if (res?.record?.taskPending?.length > 0) {
            var taskPending = res?.record?.taskPending || [];
            taskPending = taskPending.map((item) => {
              if (item.type == 11) {
                item.type = "Non-Litigation";
              } else if (item.type == 12) {
                item.type = "Litigation";
              } else if (item.type == 13) {
                item.type = "TradeMark";
              }
              if (item.assigned_to == 0) {
                item.assigned_to_username = "UnAssigned";
              }
              return { ...item };
            });

            init.child.taskPending = {
              list: taskPending,
              header: [
                // ["Select", "select"],
                ["Task Title", "subtask_title"],
                ["Priority", "priority"],
                ["Assigned To", "assigned_to_username"],
                ["Status", "status"],
                ["Due Date", "dueDate"],
                // ["ActiveStatus", "activeStatus"],
                // ["Action", "ACTION"],
              ],
            };
          }
          if (res?.record?.taskRejected?.length > 0) {
            var taskRejected = res?.record?.taskRejected || [];
            taskRejected = taskRejected.map((item) => {
              if (item.type == 11) {
                item.type = "Non-Litigation";
              } else if (item.type == 12) {
                item.type = "Litigation";
              } else if (item.type == 13) {
                item.type = "TradeMark";
              }
              if (item.assigned_to === 0) {
                item.assigned_to_username = "UnAssigned";
              }
              return { ...item };
            });

            init.child.taskRejected = {
              list: taskRejected,
              header: [
                ["Select", "select"],
                ["Task Title", "subtask_title"],
                ["Priority", "priority"],
                ["Assigned To", "assigned_to_username"],
                ["Status", "status"],
                ["Due Date", "dueDate"],
                ["ActiveStatus", "activeStatus"],
                ["Action", "ACTION"],
              ],
            };
          }
          if (res?.record?.taskCompleted?.length > 0) {
            var taskCompleted = res?.record?.taskCompleted || [];
            taskCompleted = taskCompleted.map((item) => {
              if (item.type == 11) {
                item.type = "Non-Litigation";
              } else if (item.type == 12) {
                item.type = "Litigation";
              } else if (item.type == 13) {
                item.type = "TradeMark";
              }
              if (item.assigned_to == 0) {
                item.assigned_to_username = "UnAssigned";
              }
              return { ...item };
            });

            init.child.taskCompleted = {
              list: taskCompleted,
              header: [
                // ["Select", "Select"],
                ["Task Title", "subtask_title"],
                ["Priority", "priority"],
                ["Assigned To", "assigned_to_username"],
                ["Status", "status"],
                ["Due Date", "dueDate"],
                ["ActiveStatus", "activeStatus"],
                ["Action", "ACTION"],
              ],
            };
          }
        }
        if (
          res.record.parent[0].form_id != 0 &&
          res.record.parent[0].form_id != undefined &&
          res.record.parent[0].film_id != 0 &&
          res.record.parent[0].film_id != undefined
        ) {
          store.setprops("form_id", { readonly: true });
          store.setprops("film_id", { readonly: true });
        } else {
          store.setprops("form_id", { hidden: true });
          store.setprops("film_id", { hidden: true });
        }

        store.reset(init);
      }
      store.stopLoading();
    });
  }

  async function GetProjectList(client = {}) {
    console.log("GetProjectList client", client);

    await getList({
      listUrl: "/project/getprojectlist/11",
      sort: "asc",
      field: "clientName",
      search: client.clientname,
      count: 10000,
    }).then((projects) => {
      if (projects.success) {
        projects = projects?.data?.list || [];
        projects = projects.map((project) => ({
          value: project.id,
          label: project.projectName,
        }));
        console.log("GetProjectList", projects);
        store.setprops("projectName_list", projects);
      }
    });
  }

  async function GetArtistList(Customer_id, film_id) {
    if (Customer_id != undefined && film_id != undefined) {
      await GetRecords(`/tasks/getartistid/${Customer_id}/${film_id}`).then(
        (Artists) => {
          console.log(
            "name_of_Artist_list",
            Artists,
            store.getprops("form_id")
          );
          if (Artists.success) {
            Artists = Artists?.record || [];
            Artists = Artists.map((artist) => ({
              value: artist.artist_id,
              label: artist.artist_name,
            }));
            store.setprops("name_of_Artist_list", Artists);
          } else {
            store.setprops("name_of_Artist_list", []);
          }
        }
      );
    }
  }

  function update() {
    // store.startLoading();
    let data = store.getrecord();
    data.modifiedBy = store.getuser().id;
    data.id = Number(id);
    if (typeof data.activeStatus === "string") {
      data.activeStatus = data.activeStatus == "true" ? true : false;
    }

    GetRecords("/project/getproject/" + data.project_id + "/11").then((res) => {
      if (res.success) {
        let parentendDate = new Date(res.record.parent.endDate || "");
        let parentstartDate = new Date(res.record.parent.startDate || "");
        let childDate = new Date(data.dueDate || "");
        if (parentendDate >= childDate && parentstartDate <= childDate) {
          UpdateRecord(updaterecord, data).then((res) => {
            console.log("Resonce of saveRecord - ", res);

            if (res.success) {
              SuccessAlert("Document Updated Successfully");
              store.stopLoading();
              store.navTo(
                "/" + URLPRIFIX + "/documents/view/" + res.Id.response.id,
                {
                  replace: true,
                }
              );
            } else {
              ErrorAlert(
                res?.errormessage?.response?.data ||
                " Error Found Please contact the Admin"
              );
              store.stopLoading();
            }
          });
        } else {
          store.stopLoading();

          if (parentendDate <= childDate) {
            ErrorAlert(
              "Document due date cannot be later than the Project end date!"
            );
          } else if (parentstartDate >= childDate) {
            ErrorAlert(
              "Document due date cannot be earlier than the Project start date!"
            );
          }
        }
      } else {
      }
    });
  }

  function Submit() {
    store.startLoading();
    let data = store.getrecord();
    data.modifiedBy = store.getuser().id;
    data.createdBy = store.getuser().id;
    if (typeof data.activeStatus === "string") {
      data.activeStatus = data.activeStatus == "true" ? true : false;
    }

    console.log("Sumbit", data);
    if (data.project_id === "" || data.project_id === undefined) {
      CheckMandatory("nonlitigation_document", store);
      store.stopLoading();
    } else {
      GetRecords("/project/getproject/" + data.project_id + "/11").then(
        (res) => {
          console.log("");

          if (res.success) {
            let parentendDate = new Date(res.record.parent.endDate || "");
            let parentstartDate = new Date(res.record.parent.startDate || "");
            let childDate = new Date(data.dueDate || "");
            if (CheckMandatory("nonlitigation_document", store)) {
              if (parentendDate >= childDate && parentstartDate <= childDate) {
                // saveRecord("/editor/addeditor", {
                //   editor_content: "Create your document here",
                // }).then((res) => {
                //   console.log("addeditor", res);
                //   if (res.success) {
                //     data.editor_id = res.Id.response.id;
                //   }
                //   store.stopLoading();
                data.editor_id = 0;
                saveRecord(setrecord, data).then(async (res) => {
                  console.log("Resonce of saveRecord - ", res);
                  if (res.success) {
                    SuccessAlert("Document Submitted Successfully");
                    await createTemplatetask(data, res?.Id?.response?.id);
                    store.stopLoading();
                    store.navTo(
                      "/" + URLPRIFIX + "/documents/view/" + res.Id.response.id,
                      {
                        replace: true,
                      }
                    );
                  } else {
                    ErrorAlert(
                      res?.errormessage?.response?.data ||
                      "Error Found Please contact the Admin"
                    );
                    store.stopLoading();
                  }
                });
                UpdateRecord("/forms/updateformstatus/" + data.form_id).then(
                  (res) => {
                    console.log("updateformstatus", res);
                    store.stopLoading();
                  }
                );
              } else {
                store.stopLoading();

                if (parentendDate <= childDate) {
                  ErrorAlert(
                    "Document due date cannot be later than the Project end date!"
                  );
                } else if (parentstartDate >= childDate) {
                  ErrorAlert(
                    "Document due date cannot be earlier than the Project start date!"
                  );
                }
              }
            } else {
              store.stopLoading();
            }
          } else {
            store.stopLoading();
            ErrorAlert(
              res?.errormessage?.response?.data ||
              "Error Found Please contact the Admin"
            );
          }
          store.stopLoading();
        }
      );
    }
  }

  function popupforcompany() {
    return <div>Hi Brows</div>;
  }

  // function gettemplateType() {
  //   GetRecords("/subtask/gettasktemplatetypes").then((res) => {
  //     if (res.success) {
  //       res = res?.record || [];
  //       res = res.map((artist) => ({
  //         value: artist.taskType,
  //         label: artist.taskType,
  //       }));
  //       store.setprops("taskTemplate_list", res);
  //     } else {
  //       store.setprops("taskTemplate_list", []);
  //     }
  //   });
  // }

  function gettemplateType() {
    GetRecords("/template/gettemplates").then((res) => {
      if (res.success) {
        const templateData = res.record || [];
        const formattedList = templateData.map((item) => ({
          value: item.id, // We need the ID for the workflow fetch
          label: item.template_name,
        }));
        store.setprops("taskTemplate_list", [
          { value: "", label: "Select Template" },
          ...formattedList
        ]);
      } else {
        store.setprops("taskTemplate_list", []);
      }
    });
  }

  // useEffect(() => {
  //   let data = store.getrecord();
  //   console.log("Records:", data);
  // })
  async function createTemplatetask(formData, documentid) {
    // Only proceed if a template was actually selected
    if (!formData.taskTemplate || formData.taskTemplate === "") return;

    // 1. Fetch the ordered workflow tasks for this specific template ID
    await GetRecords(`/template/getworkflow/${formData.taskTemplate}`).then(async (res) => {
      if (res.success) {
        const workflowTasks = res.record || [];

        // Calculate a base date: today, then each task stacks on the previous due date
        let rollingDate = new Date();

        const subtasksToSave = workflowTasks.map((item, idx) => {
          // 2. Calculate Due Date: rolling from previous task's end to preserve sequence gaps
          let calcDate = new Date(rollingDate);
          calcDate.setDate(calcDate.getDate() + (item.duration_days || 0));
          rollingDate = new Date(calcDate); // next task starts where this one ends

          return {
            project_id: formData.project_id,
            contact_id: formData.contact_id,
            form_id: formData.form_id || 0,
            film_id: formData.film_id || 0,
            task_id: documentid,
            subtask_title: item.task_name,
            assigned_to: item.assigned_to_user_id || 0,
            priority: item.priority || formData.priority || "Medium",
            status: "Draft",
            dueDate: calcDate.toISOString(),
            createdBy: store.getuser().id,
            modifiedBy: store.getuser().id,
            type: 11, // Non-Litigation
            activeStatus: true,
            // KEY: These two fields enable sequential workflow enforcement
            order_index: item.order_index,             // sequential position (1, 2, 3...)
            template_workflow_id: item.id,             // link back to the template row
          };
        });

        // 3. Save all tasks at once using the bulk API
        if (subtasksToSave.length > 0) {
          const saved = await saveRecord("/subtask/addmanysubtasks/11", subtasksToSave);
          console.log("[createTemplatetask] Template tasks saved:", saved);
          if (saved.success) {
            SuccessAlert(`${subtasksToSave.length} workflow task(s) created from template!`);
          }
        }
      }
    });
  }

  function NavigateToInvoice(company_id) {
    let contact_id = store.getvalue("contact_id");
    let project_id = store.getvalue("project_id");
    store.navTo(
      "/" +
      URLPRIFIX +
      "/" +
      company_id +
      "/accounts/invoice/create?proj_id=" +
      project_id +
      "&cust_id=" +
      contact_id +
      "&doc_id=" +
      id
    );
  }

  function createTask() {
    let data = store.getrecord();
    store.setrecord("nonlitigation_task", {
      task_id: id,
      project_id: data.project_id,
      form_id: data.form_id,
      contact_id: data.contact_id,
      subtask_title: "",
      assigned_to: data.assigned_to,
      dueDate: "",
      priority: data.priority,
      status: "Draft",
      description: "",
      hold_note: "",
      rejected_reason: "",
      complete_note: "",
      activeStatus: true,
      attachmenturl: [],
      child: [],
    });
    store.navTo(
      "/demo/tasks/create?project_id=readonly&contact_id=readonly&form_id=" +
      (data.form_id == "0" ? "hidden" : "readonly") +
      "&task_id=readonly"
    );
  }

  function FilmNameChange(film_id) {
    GetRecords("/api/FilmMaster/films/" + film_id).then((res) => {
      if (res.success) {
        res = res?.record?.response[0]?.film_name;
        getList({
          listUrl: "/contact/getcontacts",
          field: "film_name",
          search: res,
          sort: "asc",
          page: 1,
          count: 100,
        }).then((reslist) => {
          if (reslist.success) {
            reslist = reslist?.data.list;
            if (reslist.length === 1) {
              store.setvalue("contact_id", reslist[0].id || "");
              ClientNameChange(reslist[0].id || "");
            } else {
              store.setvalue("contact_id", "");
            }
            let list = [];
            for (let record of reslist) {
              list.push({ value: record.id, label: record.clientName });
            }
            store.setprops("clientname_list", list);
          }
        });
      }
    });
  }

  function ClientNameChange(client_id) {
    let client = store
      .getprops("clientname_list")
      ?.find((item) => item.value == client_id);
    GetProjectList(client);
    store.setprops("form_id", { hidden: true });
    store.setprops("film_id", { hidden: true });
  }

  function projectNameChange(project_id) {
    GetRecords("/project/getproject/" + project_id + "/11").then((project) => {
      if (project.success) {
        project = project?.record || {};
        if (project.parent.category_id == 1) {
          store.setprops("film_id", { readonly: true });
          if (
            store.getvalue("form_id") != 0 &&
            store.getvalue("form_id") != undefined
          ) {
            store.setprops("form_id", { readonly: true });
          } else {
            store.setprops("form_id", { hidden: false });
            store.setvalue("form_id", "0");
          }
        } else {
          store.setprops("form_id", { hidden: true });
          store.setprops("film_id", { hidden: true });
          store.setvalue("form_id", "0");
          store.setvalue("film_id", "0");
        }
        store.setvalue("contact_id", project.parent.contact_id);
        store.setvalue("film_id", project.parent.film_id);
        GetArtistList(project.parent.contact_id, project.parent.film_id);
      }
    });
  }
  function FormNameChange(form_id) {
    console.log("autofill check FormNameChange");
    GetRecords("/forms/getforms/" + form_id).then((res) => {
      res = res?.record && res?.record[0].form;
      console.log("FormNameChange", res);
      store.getvalue("contact_id") === "" &&
        store.getstore.setvalue("contact_id", res?.contact_id);
      store.getvalue("contact_id") === "" && ClientNameChange(res?.contact_id);
      store.getvalue("film_id") === "" &&
        store.setvalue("film_id", res?.film_id);
    });
  }

  return (
    <FormView
      actions={[
        {
          Name: "Back",
          onclick: () => {
            // store.navTo("/" + URLPRIFIX + "/documents/list");
            store.navback();
            store.reset(init);
          },
          visible: true,
        },
        {
          Name: "Edit",
          onclick: () => {
            store.navTo(`/${URLPRIFIX}/documents/edit/${id}`, {
              replace: true,
            });
          },
          visible: option === "view" && store.getprops("update"),
        },
        {
          Name: "Generate Invoice",
          onclick: () => {
            GetRecords(
              "/contact/companycontacts/" + store.getvalue("contact_id")
            ).then((client) => {
              if (client.success) {
                client = client?.record || {};
                client = client?.company_id?.map((item) => ({
                  value: item.company_id,
                  label: item.company_name,
                }));
                setCompanyList((prev) => {
                  return [...prev, ...client];
                });
              }
              console.log("Generate Invoice", client);
            });
            setGenerateInvoice(true);
          },
          type: "primary",
          visible:
            option === "view" &&
            [1, 4].includes(user.role) &&
            store.getvalue("status") === "completed",
        },
        {
          Name: "Submit",
          onclick: Submit,
          type: "primary",
          visible: id === undefined,
        },
        {
          Name: "Update",
          onclick: update,
          type: "primary",
          visible: option === "edit" && store.getprops("update"),
        },
        {
          Name: "Create Task",
          type: "primary",
          onclick: createTask,
          visible:
            option === "view" &&
            store?.state?.properties?.nonlitigation_task?.add,
        },
        // {
        //   Name: "Open Editor",
        //   onclick: () => {
        //     store.navtotab(
        //       "/" +
        //         URLPRIFIX +
        //         "/editor/" +
        //         (store.getvalue("editor_id") || "1")
        //     );
        //   },
        //   type: "primary",
        //   visible:
        //     option === "view" && store.getvalue("status") !== "completed",
        // },
      ]}
    >
      {GenerateInvoice && (
        <div className="absolute flex h-[80%] w-[95%] rounded-lg z-50 bg-black bg-opacity-15 backdrop-blur-sm justify-center items-center">
          <div className="flex flex-col items-center bg-secondary px-20 py-5 rounded-lg">
            <h1 className="font-bold">Please confirm the Company</h1>
            <div className="flex flex-col pt-6 pb-10 w-[80%]">
              <label>Company Name</label>
              <select
                className=" flex w-full border rounded-lg"
                onChange={(event) => {
                  setCompanyNumber(event.target.value);
                }}
              >
                {CompanyList.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex justify-evenly w-full">
              <button
                className={secondaryBTN}
                onClick={() => {
                  setGenerateInvoice(false);
                }}
              >
                Back
              </button>
              <button
                className={PrimaryBTN}
                onClick={() => {
                  if (CompanyNumber != "") {
                    NavigateToInvoice(CompanyNumber);
                  } else {
                    ErrorAlert(
                      "Please choose the company for generate invoice."
                    );
                  }
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="grid grid-cols-2 max-md:grid-cols-1 gap-6 w-full ">
        <String name="task_title" label="Document Name :" />
        {/* <Dropdown
          name="contact_id"
          label="Customer :"
          list={store.getprops("clientname_list")}
          onchange={ClientNameChange}
        /> */}
        <Dropdown
          name="project_id"
          label="Project :"
          list={store.getprops("projectName_list") || []}
          onchange={projectNameChange}
          onAdd={() => {
            let data = store.getrecord();
            console.log("autofill check Data", data);
            store.setrecord("nonlitigation_project", {
              projectName: "",
              projectDescription: "",
              startDate: "",
              endDate: "",
              priority: "",
              status: "Draft",
              film_id: data.film_id,
              category_id:
                data.film_id != 0 && data.film_id != undefined ? "1" : "",
              contact_id: data.contact_id,
              activeStatus: true,
              child: [],
              attachmenturl: [],
            });
            let url = "/" + URLPRIFIX + "/projects/create?";
            if (data.film_id != 0 && data.film_id != undefined)
              url += "&film_id=readonly&category_id=readonly";
            if (data.contact_id != 0 && data.contact_id != undefined)
              url += "&contact_id=readonly";
            store.navTo(
              url
              // "/projects/create?film_id=readonly&contact_id=readonly"
            );
          }}
          onView={(id) => {
            store.navTo("/" + URLPRIFIX + "/projects/view/" + id);
          }}
        />
        <Dropdown
          name="film_id"
          label="Film :"
          list={store.getprops("film_name_list") || []}
          onchange={FilmNameChange}
        />
        <Dropdown
          name="form_id"
          label="Artist :"
          list={store.getprops("name_of_Artist_list") || []}
        // onchange={FormNameChange}
        />
        <Dropdown
          name="assigned_to"
          label="Assigned To :"
          list={store.getprops("userName_list") || []}
        />
        {option === undefined && (
          // <Dropdown
          //   name="taskTemplate"
          //   label="Template :"
          //   list={store.getprops("taskTemplate_list") || []}
          // />
          <Dropdown
            name="taskTemplate" // This stores the ID now
            label="Template :"
            list={store.getprops("taskTemplate_list") || []}
          />
        )}
        <div className="col-span-2 max-md:col-span-1">
          <Journal
            name="description"
            label="Document Description :"
            doubleline={true}
          />
        </div>
        <DatePicker name="dueDate" label="Due Date :" />
        <Dropdown
          name="priority"
          label="Priority :"
          list={[
            { value: "High", label: "High" },
            { value: "Medium", label: "Medium" },
            { value: "Low", label: "Low" },
          ]}
        />
        <Dropdown
          name="status"
          label="Status :"
          list={[
            { value: "Draft", label: "Draft" },
            { value: "inprogress", label: "Inprogress" },
            { value: "completed", label: "Completed" },
            { value: "billed", label: "Billed" },
          ]}
        />
        <Dropdown
          name="activeStatus"
          label="Active Status :"
          list={[
            { value: true, label: "Active" },
            { value: false, label: "InActive" },
          ]}
        />

        <div className="col-span-2  max-md:col-span-1 px-2">
          <div className="font-bold text-[20px]">Attachements</div>
          <div className="grid grid-cols-5">
            {store.getvalue("attachmenturl")?.length > 0 ? (
              store.getvalue("attachmenturl").map((item, index) => {
                // console.log("test 223", item);
                return (
                  <div className="col-span-1 flex border-r pr-6 w-full  items-center">
                    <Attachement name={"attachmenturl"} fileurl={item} />
                    <button
                      className="hover:bg-tertiary p-1 h-fit w-fit rounded-full"
                      onClick={() => {
                        let arr = [];
                        store
                          .getvalue("attachmenturl")
                          .map((attachitem, attachindex) => {
                            if (attachindex !== index) {
                              arr.push(attachitem);
                            }
                          });
                        store.setvalue("attachmenturl", arr);
                      }}
                    >
                      X
                    </button>
                  </div>
                );
              })
            ) : (
              <>No Data</>
            )}
            {option !== "view" && (
              <FileInput
                prefix={"TASK" + id}
                onchange={(file) => {
                  let attachmenturl = store.getvalue("attachmenturl") || [];
                  attachmenturl.push(file);
                  store.setvalue("attachmenturl", attachmenturl);
                }}
              />
            )}
          </div>
        </div>
        {option === "view" && (
          <ChildTabsView
            className="col-span-2 max-md:col-span-1 mt-1"
            tabsList={store.getvalue("child") || {}}
            store={store}
            LoadInitData={LoadInitData}
          />
        )}
      </div>
    </FormView>
  );
};

function ChildTabsView({ tabsList = {}, className = "", store, LoadInitData }) {
  const props = getlocal("properties");
  const user = getlocal("system")?.user || {};

  const [tabs, setTabs] = useState(
    props.nonlitigation_tasks.view ? "taskPending" : ""
  );
  const [selected, setSelected] = useState([]);
  const [bulkAssignedTo, setBulkAssignedTo] = useState(0);
  const [bulkDueDate, setBulkDueDate] = useState("");

  const tabConfigs = [
    { key: "taskPending", label: "Task Pending" },
    { key: "taskCompleted", label: "Task Completed" },
    { key: "taskRejected", label: "Task Rejected" },
  ];

  const handleSelect = (record, isSelected) => {
    setSelected((prev) =>
      isSelected
        ? [...prev, record]
        : prev.filter((item) => item.id !== record.id)
    );
  };

  const handleBulkUpdate = async () => {
    if (selected.length === 0) {
      ErrorAlert("No tasks selected for bulk update.");
      return;
    }
    if (bulkAssignedTo <= 0) {
      ErrorAlert("Please select an assignee for the bulk update.");
      return;
    }

    const requestPayload = {
      task_ids: selected.map((item) => item.id),
      assigned_to: bulkAssignedTo,
      due_date: bulkDueDate ? new Date(bulkDueDate).toISOString() : null,
      modified_by: user.id,
    };

    try {
      const result = await UpdateRecord("/subtask/bulkupdatetasks/11", requestPayload);
      if (result.success) {
        SuccessAlert(`Bulk update successful for ${result.updatedCount || selected.length} tasks.`);
        LoadInitData();
        setSelected([]);
        setBulkAssignedTo(0);
        setBulkDueDate("");
      } else {
        ErrorAlert(result?.errormessage?.data || "Bulk update failed. Please try again.");
      }
    } catch (error) {
      ErrorAlert("An error occurred during bulk update. Please contact the admin.");
    }
  };

  const handleRowEditSave = async (updatedItem) => {
    const payload = {
      ...updatedItem,
      activeStatus: true,
      modifiedBy: user.id,
    };
    if (!payload.priority) payload.priority = "Medium";
    if (!payload.status) payload.status = "Draft";
    const result = await UpdateRecord(`/subtask/updatesubtask/${updatedItem.id}`, payload);
    if (result?.success) {
      SuccessAlert("Task updated successfully.");
      LoadInitData();
    } else {
      ErrorAlert("Failed to update task.");
    }
  };

  const handleDelete = (item) => {
    DeleteRecord(`/subtask/deletesubtask/${item.id}`, {
      modifiedBy: user.id,
    }).then((res) => {
      if (res.success) {
        SuccessAlert("Deleted Successfully");
        LoadInitData();
      }
      else if (res.code == 302) {
        WarningAlert("User cancelled deletion")
      }
      else {
        store.stopLoading();
        ErrorAlert(
          res?.errormessage?.response?.data ||
          "Unknown error. Please contact the admin."
        );
      }
    });
  };

  // const dropdownOptions = {
  //   assigned_to: store.getprops("userName_list") || [{ value: 0, label: "Unassigned" }],
  // };
  const dropdownOptions = {
    assigned_to_username: store.getprops("userName_list") || [{ value: 0, label: "Unassigned" }],
    priority: [
      { value: "High", label: "High" },
      { value: "Medium", label: "Medium" },
      { value: "Low", label: "Low" },
    ],
    status: [
      { value: "Draft", label: "Draft" },
      { value: "inprogress", label: "Inprogress" },
      { value: "hold", label: "Hold" },
      { value: "waitingforapproval", label: "Waiting For Approval" },
      { value: "approved", label: "Approved" },
      { value: "rejected", label: "Rejected" },
      { value: "completed", label: "Completed" },
      { value: "closedcompleted", label: "Closed Completed" },
    ],
  };

  const dateFields = ["dueDate"];

  const currentTab = tabsList[tabs] || { header: [], list: [] };
  const enrichedList = (currentTab.list || []).map(record => ({
    ...record,

    assigned_to_username: record.assigned_to_username || "Unassigned",
    activeStatus: record.activeStatus ? "Active" : "InActive"
  }));
  return (
    <div className={className}>
      {/* Tabs and Bulk Actions */}
      <div className="flex justify-between items-center border-b border-gray-200 dark:border-gray-700 dark:text-gray-400">
        <ul
          className={`flex flex-wrap text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:border-gray-700 ${className}`}
        >
          <li className="me-2 flex">
            {tabConfigs.map(({ key, label }) => {
              const hasItems = props.nonlitigation_tasks.view && tabsList?.[key]?.list?.length > 0;
              if (!hasItems) return null;
              const isActive = tabs === key;

              return (
                <button
                  key={key}
                  className={`p-2 text-primary text-[16px] rounded-t-lg hover:bg-tertiary hover:text-primary ${isActive ? "bg-Ocean_Blue text-secondary" : "bg-Alice_Blue"
                    }`}
                  onClick={() => setTabs(key)}
                >
                  {`${label}${isActive ? ` - ${tabsList[key]?.list?.length || 0}` : ""}`}
                </button>
              );
            })}
          </li>
        </ul>
        {["taskPending", "taskRejected"].includes(tabs) && selected.length > 0 && (
          <div className="flex items-center gap-2 px-2">
            <Dropdown
              className={{ lable: "min-w-fit", field: "", input: "" }}
              name="bulk_assigned_to"
              label="Assigned To:"
              list={dropdownOptions.assigned_to_username}
              value={bulkAssignedTo}
              onchange={(value) => setBulkAssignedTo(value)}
            />
            <DatePicker
              name="bulk_due_date"
              label="Due Date (Optional):"
              value={bulkDueDate}
              onchange={(value) => setBulkDueDate(value)}
            />
            <button
              className="py-2 px-6 rounded-xl font-bold text-[12px] bg-primary text-secondary"
              onClick={handleBulkUpdate}
            >
              Save
            </button>
          </div>
        )}
      </div>
      <EditableTable
        headers={currentTab.header}
        records={enrichedList}
        selected={selected}
        onSelect={handleSelect}
        onRowClick={(item) => {
          store.removemodule("nonlitigation_task");
          store.navTo(`/${URLPRIFIX}/tasks/view/${item.id}`);
        }}
        onSaveEdit={handleRowEditSave}
        ondelete={props.nonlitigation_tasks.delete ? handleDelete : undefined}
        dropdownOptions={dropdownOptions}
        dateFields={dateFields}
      />
    </div>
  );
}

function EditableTable({
  headers,
  records,
  selected,
  onSelect,
  onRowClick,
  onSaveEdit,
  ondelete,
  dropdownOptions = {},
  dateFields = [],
}) {
  const [editRowId, setEditRowId] = useState(null);
  const [editData, setEditData] = useState({});

  const handleCheckboxChange = (record, isChecked) => {
    onSelect(record, isChecked);
  };

  const handleBulkSelect = (e) => {
    const isChecked = e.target.checked;
    records.forEach((rec) => onSelect(rec, isChecked));
  };

  const startEdit = (record) => {
    setEditRowId(record.id);
    setEditData({ ...record });
  };

  const saveEdit = () => {
    if (editRowId !== null) {
      onSaveEdit(editData);
      setEditRowId(null);
    }
  };

  const cancelEdit = () => {
    setEditRowId(null);
    setEditData({});
  };

  return (
    <table className="min-w-full border mt-4">
      <thead className="bg-gray-100">
        <tr>
          <th className="p-2 border">
            <input
              type="checkbox"
              checked={selected.length === records.length && records.length > 0}
              onChange={handleBulkSelect}
              onClick={(e) => e.stopPropagation()}
            />
          </th>
          <th className="p-2 border">S.No</th>
          {headers.map(([label, key]) => (
            <th key={key} className="p-2 border text-left">
              {label}
            </th>
          ))}
          <th className="p-2 border">Actions</th>
        </tr>
      </thead>
      <tbody>
        {records.map((row, index) => {
          const isSelected = selected.some((s) => s.id === row.id);
          const isEditing = editRowId === row.id;
          const titleColumnKey = headers[0]?.[1];

          return (
            <tr
              key={row.id}
              className={`hover:bg-gray-50 ${isEditing ? "bg-yellow-50" : ""}`}
            // onClick={() => {
            //   if (!isEditing) onRowClick(row);
            // }}
            >
              <td className="p-2 border">
                <input
                  type="checkbox"
                  checked={isSelected}
                  onChange={(e) => handleCheckboxChange(row, e.target.checked)}
                  onClick={(e) => e.stopPropagation()}
                />
              </td>
              <td className="p-2 border">{index + 1}</td>
              {headers.map(([label, key]) => (
                <td key={key} className="p-2 border">
                  {isEditing ? (
                    dropdownOptions[key] ? (
                      <select
                        className="border p-1 w-full"
                        value={
                          key === "assigned_to_username"
                            ? editData.assigned_to
                            : editData[key] || ""
                        }
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            [key === "assigned_to_username" ? "assigned_to" : key]:
                              e.target.value,
                          })
                        }
                        onClick={(e) => e.stopPropagation()}
                      >
                        <option value="">Select</option>
                        {dropdownOptions[key].map((opt) => (
                          <option key={opt.value} value={opt.value}>
                            {opt.label}
                          </option>
                        ))}
                      </select>
                    ) : dateFields.includes(key) ? (
                      <input
                        type="date"
                        className="border p-1 w-full"
                        value={editData[key] ? editData[key].slice(0, 10) : ""}
                        onChange={(e) => {
                          const isoDate = e.target.value
                            ? new Date(e.target.value).toISOString()
                            : "";
                          setEditData({ ...editData, [key]: isoDate });
                        }}
                        onClick={(e) => e.stopPropagation()}
                      />
                    ) : (
                      <input
                        className="border p-1 w-full"
                        value={editData[key] || ""}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            [key]: e.target.value,
                          })
                        }
                        onClick={(e) => e.stopPropagation()}
                      />
                    )
                  ) : (
                    key === titleColumnKey ? (
                      /* **TITLE CELL: CLICKABLE + HIGHLIGHTED** */
                      <div
                        className="cursor-pointer text-blue-600 hover:text-blue-800 hover:underline font-semibold flex items-center"
                        onClick={(e) => {
                          e.stopPropagation();
                          onRowClick(row);
                        }}
                      >
                        <span className="mr-1 text-xs">🔗</span>
                        {row[key]}
                      </div>
                    ) : (
                      /* **OTHER CELLS: NON-CLICKABLE** */
                      <span className="cursor-default">{row[key]}</span>
                    )
                  )}                </td>
              ))}
              <td className="p-2 border whitespace-nowrap">
                {isEditing ? (
                  <>
                    <button
                      className="text-green-600 mr-2"
                      onClick={(e) => {
                        e.stopPropagation();
                        saveEdit();
                      }}
                    >
                      <FaCheck />
                    </button>
                    <button
                      className="text-gray-600"
                      onClick={(e) => {
                        e.stopPropagation();
                        cancelEdit();
                      }}
                    >
                      <FaTimes />
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      className="text-blue-600 mr-2"
                      onClick={(e) => {
                        e.stopPropagation();
                        startEdit(row);
                      }}
                    >
                      <FaEdit />
                    </button>
                    {ondelete && (
                      <button
                        className="text-red-600"
                        onClick={(e) => {
                          e.stopPropagation();
                          ondelete(row);
                        }}
                      >
                        <FaTrash />
                      </button>
                    )}
                  </>
                )}
              </td>
            </tr>
          );
        })}
        {records.length === 0 && (
          <tr>
            <td
              colSpan={headers.length + 3}
              className="text-center p-4 text-gray-500"
            >
              No records found.
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

export default DocumentsForm;
